<template>
  <div class="chart-wrap">
    <div class="big-chart left" :class="{ show: chartIndex === 1 }">
      <div class="big-chart-header"></div>
      <div class="big-chart-main">
        <p>
          茶产业是福建地理标志性产品，茶文化体系深刻地影响东南亚东北亚地区的消费。
        </p>
        <p>
          将茶文化、茶产业、茶科技等通过跨境电商销售模式，强化福建与东南亚国家的贸易合作；助推RCEP自由贸易协定，推动“一带一路”高质量发展。
        </p>
        <p>
          Shopee是东南亚及中国台湾地区的电商平台。自2015年在新加坡成立以来，Shopee业务范围辐射新加坡、马来西亚、菲律宾、泰国、越南、巴西等10余个市场。
          [106] Shopee是东南亚发展最快的电商平台，是国货出海东南亚首选平台。
        </p>
        <p>
          东南亚是“21世纪海上丝绸之路”建设的枢纽地区，且因地缘、人口、经济发展潜力因素叠加，东南亚日渐成为电商发展的蓝海市场及中国跨境商家开展出口电商的首选。
        </p>
        <p>
          我国是世界上重要的文明古国，无论是文化的成熟度，还是整个文化体系的完善度，实际上都有着其他国家和地区所无法比拟的优势。当然，就我国所处的地理位置而言，其作为东亚地区重要的国家，其对周围地区，如东南亚地和东北亚地区所带来的文化影响力是首要影响力，可以说，这一地区是我国整个茶文化体系传承与影响的重要渗透地区。
        </p>
        <p>
          公司最近准备向
          <span>shopee平台</span
          >上架关于茶类的产品，你作为公司合伙人，你将负责这次茶产业项目的
          <span>平台调研产品</span
          >、<span>数据挖掘</span>、<span>数据分析</span>、<span>上架茶产品</span>等工作。
        </p>
        <div class="big-chart-main-footer">
          <div class="btn" @click="$emit('finish', 2)">
            我明白了
          </div>
          <div class="btn" @click="$emit('finish', 0)">
            关闭
          </div>
        </div>
      </div>
      <img
        class="person-image"
        src="./../../../assets/image/simulation/people-img-2.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "chartComponent1",
  props: ["chartIndex"],
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.big-chart {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in;
  &.left {
    left: 10px;
    bottom: 10px;
    transform: translateX(-110%);
    .person-image {
      left: 0;
      bottom: 0;
    }
    .big-chart-main {
      padding: 30px 30px 30px 136px;
      margin-left: 200px;
      margin-bottom: 26px;
      box-shadow: 23px 0 20px 10px #63759d;
    }
  }
  &.right {
    right: 10px;
    bottom: 10px;
    transform: translateX(110%);
    .person-image {
      right: 0;
      bottom: 0;
    }
    .big-chart-main {
      padding: 30px 136px 30px 30px;
      margin-right: 200px;
      margin-bottom: 26px;
      box-shadow: -23px 0 20px 10px #63759d;
    }
  }
  &.left.show {
    transform: translateX(0);
    transition: all 0.3s ease-in;
  }
  &.right.show {
    transform: translateX(0);
    transition: all 0.3s ease-in;
  }
  .close {
    border: 2px solid #8495b1;
    width: 80px;
    height: 40px;
    border-radius: 8px;
    box-shadow: 0px -6px 8px 1px #8495b1;
    background: #ffffff;
    cursor: pointer;
    position: relative;
    i {
      animation: rightToleft 2s infinite;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 26px;
      color: #5c6d92;
    }
  }
  .btn {
    cursor: pointer;
    border: 2px solid #8495b1;
    width: 80px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 8px;
    box-shadow: 10px 10px 10px #8495b1;
    background: #ffffff;
    margin-left: 10px;
  }
  .person-image {
    position: absolute;

    width: 384px;
    z-index: 99;
    filter: drop-shadow(16px 18px 10px #155e9e);
  }
  .big-chart-main {
    flex-grow: 1;
    flex-shrink: 1;

    border-radius: 10px;
    z-index: 98;
    font-size: 16px;
    backdrop-filter: blur(26px);
    background: transparent;
    p {
      width: 700px;
      padding: 10px;
      line-height: 22px;
      border: 2px solid #8495b1;
      box-shadow: 10px 10px 10px #8495b1;
      border-radius: 10px;
      margin-bottom: 10px;
      background: #ffffff;
      span {
        font-size: 18px;
        font-weight: bolder;
        color: red;
      }
    }
    .big-chart-main-footer {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
@keyframes rightToleft {
  0% {
    opacity: 1;
    transform: translate(10%, -50%);
  }

  99% {
    transform: translate(-100%, -50%);
  }
  100% {
    opacity: 0;
  }
}
</style>
